export default "__VITE_ASSET__DHmGEx5d__"